import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {capturePaypalPayment} from "../api/apiClient";
import PaymentConfirmation from "../components/PaymentConfirmation";
import {trackEvent} from "../utils/fbPixel";

const PaypalPaymentConfirmationPage = () => {
    const [searchParams] = useSearchParams();
    const [paymentStatus, setPaymentStatus] = useState(null); // null, "success", "event_full", "general_error"

    useEffect(() => {
        const paypalOrderId = searchParams.get("token");

        if (paypalOrderId) {
            capturePaypalPayment(paypalOrderId)
                .then((data) => {
                    if (data === "success") {
                        setPaymentStatus("success");
                        // Track successful purchase
                        trackEvent('Purchase', {currency: 'EUR'});
                    }
                    else if (data === "event_is_full") {
                        setPaymentStatus("event_full");
                    }
                    else {
                        setPaymentStatus("general_error");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setPaymentStatus("general_error");
                });
        }
    }, [searchParams]);



    return <PaymentConfirmation paymentStatus={paymentStatus} paymentProvider="PayPal" />;
};

export default PaypalPaymentConfirmationPage;
